import { FC } from 'react';
import { useIsEmailVerified } from '~/adapters/services/profiles/profile/hooks';
import { PWC } from '~/adapters/typescript/propsWithChildren';
import { Loader } from '~/components/Loader/loader';
import { PageHeader } from '~/components/PageHeader/PageHeader';
import { profilesActivateUrl } from '~/adapters/services/profiles/links';

const VerifyEmailLoader: FC<{ pageHeader: string }> = ({ pageHeader }) => {
    return (
        <>
            {pageHeader && <PageHeader>{pageHeader}</PageHeader>}
            <Loader title="Loading..." />
        </>
    );
};

export const VerifiedEmailGuard: FC<PWC<{ pageHeader: string }>> = ({ children, pageHeader }) => {
    const { isEmailVerified, isLoading } = useIsEmailVerified();

    if (isLoading) {
        return <VerifyEmailLoader pageHeader={pageHeader} />;
    }

    if (!isEmailVerified) {
        window.location.replace(profilesActivateUrl());

        return <VerifyEmailLoader pageHeader={pageHeader} />;
    }

    return <>{children}</>;
};
